import { render } from "./NotificationLink.vue?vue&type=template&id=872011a0"
import script from "./NotificationLink.vue?vue&type=script&lang=js"
export * from "./NotificationLink.vue?vue&type=script&lang=js"

import "./NotificationLink.vue?vue&type=style&index=0&id=872011a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__